import React from 'react';
import elementMap from './elementMap';
import { getNodeTextContent } from './services';
import Typography from '../Typography';
import { DOMNodeExtended, DOMNodeHandler } from './types';


const handleFirstParagraph: DOMNodeHandler = (
  node: DOMNodeExtended,
  tagsIteratedRef,
) => {
  if (node?.name === 'p' && !tagsIteratedRef.current.includes('p')) {
    return <Typography variant="bodyPullout">{getNodeTextContent(node)}</Typography>;
  } else {
    return null;
  }
};


const handleElementMap: DOMNodeHandler = ({ attribs = {} }) => {
  const name = attribs['data-block-name'];
  const dataString = attribs['data-block-content-uri-encoded'];
  if (typeof name !== 'string' || typeof dataString !== 'string') return null;

  const decodedString = decodeURIComponent(dataString);
  const data = JSON.parse(decodedString) as unknown;
  const elementMapEntry = elementMap[name as keyof typeof elementMap];
  if (!elementMapEntry) return null;

  const isValidData = elementMapEntry.schema.isValidSync(data);

  if (isValidData) {
    const Component = elementMapEntry.component;
    return <Component {...elementMapEntry.dataToProps(data)} />;
  } else {
    // eslint-disable-next-line no-console
    console.info(`data integrity check failed in ContentParser for ${name}`);
    return null;
  }
};

/**
 *
 * @param node extended version of the node passed by html-react-parser
 * @param tagsIteratedRef a ref containing a string array of tagnames iterated so far
 * @returns null or JSX.Element as required by html-react-parser.
 * Null if the node was not replaced, Element if it was replaced
 *
 */
const replace: DOMNodeHandler = (
  node: DOMNodeExtended,
  tagsIteratedRef,
) => {
  // handlers are run in sequence until the first one returns a JSX.Element
  const handlers: DOMNodeHandler[] = [
    handleElementMap,
    handleFirstParagraph,
  ];

  let res = null;
  for (let i = 0; i < handlers.length; i += 1) {
    const handler = handlers[i];
    const handlerResult = handler(node, tagsIteratedRef);
    if (handlerResult) {
      res = handlerResult;
      break;
    }
  }
  if (node.name) tagsIteratedRef.current.push(node.name);
  return res;
};

export default replace;
